// @ts-nocheck
import AnalysisSetup from './AnalysisSetup';

export default AnalysisSetup;
